import type { SVGProps } from 'react';

/** One icon set, drawn on a 24px grid so every control lines up. */
const base = {
  width: 22,
  height: 22,
  viewBox: '0 0 24 24',
  fill: 'currentColor',
  'aria-hidden': true,
  focusable: false,
} as const;

type P = SVGProps<SVGSVGElement>;

export const MicIcon = (p: P) => (
  <svg {...base} {...p}>
    <path d="M12 14a3 3 0 0 0 3-3V5a3 3 0 1 0-6 0v6a3 3 0 0 0 3 3Zm5-3a5 5 0 0 1-10 0H5a7 7 0 0 0 6 6.92V21h2v-3.08A7 7 0 0 0 19 11h-2Z" />
  </svg>
);

export const MicOffIcon = (p: P) => (
  <svg {...base} {...p}>
    <path d="M15 11V5a3 3 0 0 0-5.9-.75l5.8 5.8c.07-.34.1-.7.1-1.05ZM4.4 3 3 4.4l6 6V11a3 3 0 0 0 4.2 2.75l1.5 1.5A5 5 0 0 1 7 11H5a7 7 0 0 0 6 6.92V21h2v-3.08a6.9 6.9 0 0 0 2.6-.9L19.6 20 21 18.6 4.4 3Z" />
  </svg>
);

export const SpeakerIcon = (p: P) => (
  <svg {...base} {...p}>
    <path d="M3 9v6h4l5 4V5L7 9H3Zm13.5 3A4.5 4.5 0 0 0 14 7.97v8.06A4.5 4.5 0 0 0 16.5 12Zm0-8.32v2.08A7 7 0 0 1 20 12a7 7 0 0 1-3.5 6.24v2.08A9 9 0 0 0 22 12a9 9 0 0 0-5.5-8.32Z" />
  </svg>
);

export const CamIcon = (p: P) => (
  <svg {...base} {...p}>
    <path d="M4 6h10a2 2 0 0 1 2 2v1.5l4-2.5v10l-4-2.5V16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2Z" />
  </svg>
);

export const CamOffIcon = (p: P) => (
  <svg {...base} {...p}>
    <path d="M4.4 3 3 4.4 4.6 6H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10c.3 0 .6-.07.87-.19L19.6 20 21 18.6 4.4 3ZM16 9.5 20 7v10l-1.3-.8L16 13.5v-4Z" />
  </svg>
);

export const ScreenIcon = (p: P) => (
  <svg {...base} {...p}>
    <path d="M3 4h18a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-7v2h3v2H7v-2h3v-2H3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1Zm9 3-4 4h2.5v3h3v-3H16l-4-4Z" />
  </svg>
);

export const ScreenOffIcon = (p: P) => (
  <svg {...base} {...p}>
    <path d="M4.4 3 3 4.4 4.6 6H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h7v2H7v2h10v-2h-3v-2h1.6l4 4L21 20.6 4.4 3ZM22 7a1 1 0 0 0-1-1H8.8l12 12c.13-.16.2-.36.2-.57V7Z" />
  </svg>
);

export const ChatIcon = (p: P) => (
  <svg {...base} {...p}>
    <path d="M4 3h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H8l-5 4V5a2 2 0 0 1 2-2Zm3 5v2h10V8H7Zm0 4v2h7v-2H7Z" />
  </svg>
);

export const LeaveIcon = (p: P) => (
  <svg {...base} {...p}>
    <path d="M12 9c-1.6 0-3.15.25-4.6.7v3.1c0 .4-.23.74-.57.9-1 .5-1.9 1.14-2.7 1.9-.18.18-.43.3-.7.3a.99.99 0 0 1-.71-.3L.29 13.08a.99.99 0 0 1-.29-.7c0-.29.12-.54.3-.72C3.34 8.78 7.46 7 12 7s8.66 1.78 11.7 4.66c.18.18.3.43.3.72 0 .28-.12.53-.3.71l-2.43 2.52a.99.99 0 0 1-.7.3c-.28 0-.53-.12-.71-.3a11.6 11.6 0 0 0-2.7-1.9.998.998 0 0 1-.57-.9v-3.1A15.7 15.7 0 0 0 12 9Z" />
  </svg>
);

export const CopyIcon = (p: P) => (
  <svg {...base} {...p}>
    <path d="M16 1H4a2 2 0 0 0-2 2v14h2V3h12V1Zm3 4H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2Zm0 16H8V7h11v14Z" />
  </svg>
);

export const CheckIcon = (p: P) => (
  <svg {...base} {...p}>
    <path d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2Z" />
  </svg>
);

export const StatsIcon = (p: P) => (
  <svg {...base} {...p}>
    <path d="M4 20h3v-8H4v8Zm6.5 0h3V4h-3v16ZM17 20h3v-5h-3v5Z" />
  </svg>
);

export const MoreIcon = (p: P) => (
  <svg {...base} {...p}>
    <path d="M6 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z" />
  </svg>
);

export const BackIcon = (p: P) => (
  <svg {...base} {...p}>
    <path d="m14.7 5.3-1.4-1.4L5.2 12l8.1 8.1 1.4-1.4L9 13h10v-2H9l5.7-5.7Z" />
  </svg>
);

export const LockIcon = (p: P) => (
  <svg {...base} {...p}>
    <path d="M17 9h-1V7a4 4 0 0 0-8 0v2H7a2 2 0 0 0-2 2v9h14v-9a2 2 0 0 0-2-2Zm-7-2a2 2 0 1 1 4 0v2h-4V7Zm3 9.73V18h-2v-1.27a2 2 0 1 1 2 0Z" />
  </svg>
);

export const ExpandIcon = (p: P) => (
  <svg {...base} {...p}>
    <path d="M4 4h7v2H6v5H4V4Zm16 0v7h-2V6h-5V4h7ZM4 13h2v5h5v2H4v-7Zm16 0v7h-7v-2h5v-5h2Z" />
  </svg>
);

export const CollapseIcon = (p: P) => (
  <svg {...base} {...p}>
    <path d="M9 4h2v7H4V9h5V4Zm4 0h2v5h5v2h-7V4Zm-9 9h7v7h-2v-5H4v-2Zm9 0h7v2h-5v5h-2v-7Z" />
  </svg>
);

export const CloseIcon = (p: P) => (
  <svg {...base} {...p}>
    <path d="M19 6.4 17.6 5 12 10.6 6.4 5 5 6.4 10.6 12 5 17.6 6.4 19 12 13.4 17.6 19 19 17.6 13.4 12 19 6.4Z" />
  </svg>
);

export const SendIcon = (p: P) => (
  <svg {...base} {...p}>
    <path d="M2 21 23 12 2 3v7l15 2-15 2v7Z" />
  </svg>
);

export const PeopleIcon = (p: P) => (
  <svg {...base} {...p}>
    <path d="M16 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-8 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5Zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5Z" />
  </svg>
);

export const VideoPlusIcon = (p: P) => (
  <svg {...base} {...p}>
    <path d="M4 6h10a2 2 0 0 1 2 2v1.5l4-2.5v10l-4-2.5V16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2Zm4 3v2H6v2h2v2h2v-2h2v-2h-2V9H8Z" />
  </svg>
);

export const LinkIcon = (p: P) => (
  <svg {...base} {...p}>
    <path d="M3.9 12a3.1 3.1 0 0 1 3.1-3.1h4V7H7a5 5 0 0 0 0 10h4v-1.9H7A3.1 3.1 0 0 1 3.9 12ZM8 13h8v-2H8v2Zm9-6h-4v1.9h4a3.1 3.1 0 0 1 0 6.2h-4V17h4a5 5 0 0 0 0-10Z" />
  </svg>
);

export const HeadphonesIcon = (p: P) => (
  <svg {...base} {...p}>
    <path d="M12 3a9 9 0 0 0-9 9v6a3 3 0 0 0 3 3h2v-8H5v-1a7 7 0 1 1 14 0v1h-3v8h2a3 3 0 0 0 3-3v-6a9 9 0 0 0-9-9Z" />
  </svg>
);

export const RecordIcon = (p: P) => (
  <svg {...base} {...p}>
    <path d="M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm0 2a7 7 0 1 1 0 14 7 7 0 0 1 0-14Zm0 2.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Z" />
  </svg>
);

export const PipIcon = (p: P) => (
  <svg {...base} {...p}>
    <path d="M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6h-2V5H5v14h6v2H5a2 2 0 0 1-2-2V5Zm10 8a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-7Z" />
  </svg>
);

export const SparkleIcon = (p: P) => (
  <svg {...base} {...p}>
    <path d="M10 2 11.9 7.6 17.5 9.5 11.9 11.4 10 17 8.1 11.4 2.5 9.5 8.1 7.6 10 2Zm8 10 1 2.9 2.9 1-2.9 1-1 2.9-1-2.9-2.9-1 2.9-1 1-2.9Z" />
  </svg>
);

export const FlipCamIcon = (p: P) => (
  <svg {...base} {...p}>
    <path d="M16 7h-1l-1-1h-4L9 7H8a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2Zm-4 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4ZM8.57.51l4.48 4.48V2.04A9.5 9.5 0 0 1 22 10.99h2C23.34 4.02 16.49-1.59 8.57.51Zm2.38 21.45A9.5 9.5 0 0 1 2 13.01H0c.66 6.97 7.51 12.58 15.43 10.48l-4.48-4.48v2.95Z" />
  </svg>
);
